export default __webpack_public_path__ + "static/media/photo.6a8bd4d0.jpg";